import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=9f17a1e4"
import script from "./checkbox.vue?vue&type=script&lang=ts"
export * from "./checkbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports